/*
 * @Author: liqiang70 liqiang70@58.com
 * @Date: 2025-05-14 16:05:40
 * @LastEditors: liqiang70 liqiang70@58.com
 * @LastEditTime: 2025-10-27 16:28:48
 * @Description: 
 */
import React from 'react';
import { IMG_WOS } from '../../constants';
import "./index.scss";

const Footer = () => {

    return (
        <footer className="chefu-footer">
            <div className="chefu-footer-main chefu-section-main">
                <div className="chefu-footer-info">
                    <div className="chefu-footer-contact">
                        <p className="chefu-footer-title">联系我们</p>
                        <p className="chefu-footer-subtitle">客服热线</p>
                        <p className="chefu-footer-phone">
                            <a href="tel:18610662763">186 1066 2763</a>
                        </p>
                        <p className="chefu-footer-subtitle">邮箱</p>
                        <p className="chefu-footer-text">
                            58chefu@58.com
                        </p>
                    </div>
                    <div className="chefu-footer-wx">
                        <img
                            src={`${IMG_WOS}146u8vnh__w624_h624.png`}
                            alt="58车服公众号"
                            className="chefu-footer-wxcode"
                        />
                        <p>
                            关注58车服公众号
                            <br />
                            获取更多资讯
                        </p>
                    </div>
                    <div className="chefu-footer-address">
                        <img
                            src={`${IMG_WOS}uriuoknb__w402_h136.png`}
                            alt="58车服logo"
                            className="chefu-footer-logo"
                        />
                        <p>地址：北京市朝阳区酒仙桥北路甲10号院</p>
                        {/* <a
                            href="/"
                            className="chefu-footer-link"
                            target='_blank'
                            rel="nofollow"
                        >查看招商手册</a> */}
                    </div>
                </div>
                <div className="chefu-footer-copyright">
                    <p>
                        版权所有  Copyright © {new Date().getFullYear()} 北京五八汽车服务有限公司
                    </p>
                    <p>
                        <a
                            className="chefu-footer-beian"
                            href="//beian.miit.gov.cn"
                            target="_blank"
                            rel="nofollow"
                        >
                            京ICP备2025141905号-2
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;